import { render } from "./ReminderModal.vue?vue&type=template&id=6998f510&scoped=true"
import script from "./ReminderModal.vue?vue&type=script&lang=js"
export * from "./ReminderModal.vue?vue&type=script&lang=js"

import "./ReminderModal.vue?vue&type=style&index=0&id=6998f510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6998f510"]])

export default __exports__